import { h } from 'preact';
export const Type = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "4 7 4 4 20 4 20 7" }),
        h("line", { x1: "9", y1: "20", x2: "15", y2: "20" }),
        h("line", { x1: "12", y1: "4", x2: "12", y2: "20" })));
};
//# sourceMappingURL=type.js.map